module.exports = __webpack_public_path__ + "img/swab1_7-8-2021.cee77ee5.jpg";